module.exports = __webpack_public_path__ + "static/media/public-safety.81f3ef57.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/public-safety.jpeg
// module id = 390
// module chunks = 0